import React from 'react';
export const CFIconChevronsLeft = {
    alias: 'chevrons-left',
    defaultTitle: 'ChevronsLeft',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'm18.768 6.64-4.476 5.37 4.315 5.363a1 1 0 0 1-1.559 1.254l-4.828-6a1 1 0 0 1 .011-1.267l5-6a1 1 0 0 1 1.537 1.28Zm-8.536-1.28a1 1 0 0 1 1.536 1.28l-4.476 5.37 4.315 5.362a1 1 0 0 1-1.558 1.255l-4.828-6a1 1 0 0 1 .011-1.268l5-6Z' }))),
};
